module.exports = __webpack_public_path__ + "img/appStore.bad39c4f.png";